import { FcGoogle } from "react-icons/fc";
import { FaFacebookF } from "react-icons/fa";
import InputField from "../components/input/InputField";
import { useState, useEffect } from "react";
import { BsEyeSlash, BsEye, BsArrowRight, BsArrowRightShort } from "react-icons/bs";
import { employeeFetchBoss, signInURL } from "../api/endpoints";
import { useNavigate } from "react-router-dom";
import { setUser } from "../slice/webStoreUserSlice";
import { useDispatch } from "react-redux";
import { ButtonLoader } from "../components/uxCollections/Loaders";
import backImage from "../assetsStatic/bgImage.webp";
import "../styles/signUp-in.css";
import { RiAdminFill } from "react-icons/ri";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";

const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true); //
  const [password, setPassword] = useState("");
  const [isPasswordIncorrect, setIsPasswordIncorrect] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const regexForEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  console.log(window.location.pathname);

  useEffect(() => {
    if (regexForEmail.test(email)) {
      setIsEmailValid(true);
    } else {
      email.length > 4 && setIsEmailValid(false);
      setIsFormValid(false);
    }
  }, [email]);

  useEffect(() => {
    console.log(password);
    if (email && password.length > 4 && isEmailValid) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [isEmailValid, password]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignIn = async () => {
    setIsLoading(true);
    console.log(email);

    try {
      console.log(email, password);
      let response = await fetch(employeeFetchBoss, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email.toLowerCase(), password }),
      });
      /*   let boss = await response.json();
      console.log(boss); */

      if (response.status === 404) {
        uiAlert("Boss not found, please contact support", "error");
        setIsLoading(false);
        return;
      }
      if (!response.ok) {
        uiAlert("An error occurred, please try again", "error");
        setIsLoading(false);
        return;
      }

      let data = await response.json();
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("lastInteractionAt", Date.now().toString());
      dispatch(setUser(data.boss));
      navigate("/mystores");

      console.log(data);

      return;
    } catch (error) {
      uiAlert(error);
    } finally {
      setIsLoading(false);
      setPassword("");
    }
  };

  return (
    <>
      {/*  <div className='signInDivWrapper'>
        <img src={backImage} className='bgImage84' />
        <div className='signinForm'>
          <div style={{ textAlign: "center" }}>
            <img
              style={{ width: "180px" }}
              src='https://res.cloudinary.com/ebuka1122/image/upload/v1747600616/StorelenseLogos/Group_2823_fsprsy.png'
              alt='storelense logo'
            />
          </div>
        
          <p style={{ fontSize: "1.3rem", marginBottom: "28px" }} className='titleSign'>
            Sign in to access store
          </p>
          <div className='signinSocials'>
            <FcGoogle /> <p>Sign in with google</p>
          </div>
          <div className='signinSocials'>
            <FaFacebookF color='rgb(39, 88, 194)' /> <p>Sign in with facebook</p>
          </div>
          <p>Or</p>
          <InputField style={{ top: "18px" }} placeholder={"Email *"} setValue={setEmail} value={email} type={"text"} newStyle={JSON.stringify({})} />
          {!isEmailValid && email.length > 4 && (
            <p style={{ alignSelf: "flex-start" }} className='emailValidationP'>
              Email not valid
            </p>
          )}
          <div className='inputFieldAnimated passwordIn'>
            <input
              onKeyDown={(e) => isFormValid && e.key === "Enter" && handleSignIn()}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
              required={true}
            />
            <p>Password*</p>
            {showPassword ? (
              <BsEye style={{ cursor: "pointer" }} onClick={() => setShowPassword(false)} />
            ) : (
              <BsEyeSlash style={{ cursor: "pointer" }} onClick={() => setShowPassword(true)} />
            )}
          </div>
          <div className='forgottenPassword'>
            <p>Forgotten password?</p>
          </div>
          {isFormValid ? (
            isLoading ? (
              <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='signUpbutton'>
                {" "}
                <ButtonLoader />
              </button>
            ) : (
              <button id='signInButton2' onClick={() => handleSignIn()} className='signUpbutton'>
                {" "}
                Sign in
              </button>
            )
          ) : (
            <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='signUpbutton'>
              {" "}
              Sign in
            </button>
          )}

          <p style={{ marginTop: "10px" }}>
            New to member?{" "}
            <span
              style={{ cursor: "pointer", color: "rgb(39, 88, 194)", fontWeight: "700", textDecoration: "underline", marginLeft: "5px" }}
              onClick={() => navigate("/sign-up")}
            >
              Register
            </span>
          </p>
        </div>
      </div> */}
      <div className='signInContainerEmp'>
        <div class='pos-login-container'>
          <div class='pos-graphics-section'>
            <div class='pos-floating-shapes'>
              <div class='pos-shape-circle pos-shape-one'></div>
              <div class='pos-shape-circle pos-shape-two'></div>
              <div class='pos-shape-circle pos-shape-three'></div>
            </div>

            <div class='pos-illustration-wrapper'>
              <svg class='pos-main-illustration' viewBox='0 0 400 300' xmlns='http://www.w3.org/2000/svg'>
                <rect x='50' y='200' width='300' height='15' fill='#d4a574' opacity='0.3' />

                <rect x='70' y='165' width='70' height='50' rx='5' fill='#f5f5f5' />
                <rect x='75' y='170' width='60' height='15' rx='2' fill='#3272ED' />
                <rect x='80' y='190' width='50' height='3' fill='#cbd5e0' />
                <rect x='80' y='197' width='50' height='3' fill='#cbd5e0' />
                <rect x='80' y='204' width='50' height='3' fill='#cbd5e0' />

                <rect x='95' y='150' width='20' height='15' fill='#ffffff' opacity='0.9' />

                <ellipse cx='200' cy='215' rx='45' ry='8' fill='#2d3748' />
                <rect x='185' y='185' width='30' height='30' rx='3' fill='#2d3748' />

                <rect x='145' y='85' width='110' height='100' rx='8' fill='#1a202c' />
                <rect x='150' y='90' width='100' height='90' rx='4' fill='#4a5568' />

                <circle cx='200' cy='115' r='15' fill='#d4af37' opacity='0.3' />
                <rect x='165' y='140' width='70' height='8' rx='2' fill='#3272ED' opacity='0.6' />
                <rect x='165' y='155' width='50' height='6' rx='2' fill='#4ba3c3' opacity='0.6' />
                <rect x='165' y='165' width='60' height='6' rx='2' fill='#cbd5e0' opacity='0.4' />

                <rect x='145' y='85' width='110' height='100' rx='8' fill='none' stroke='#ffffff' stroke-width='1' opacity='0.2' />

                <ellipse cx='290' cy='215' rx='25' ry='6' fill='#2d3748' />
                <rect x='278' y='180' width='24' height='35' rx='3' fill='#2d3748' />

                <path d='M 285 180 Q 285 165 290 155 Q 295 165 295 180' fill='#2d3748' />
                <ellipse cx='290' cy='155' rx='6' ry='8' fill='#4a5568' />

                <rect x='280' y='175' width='20' height='8' rx='2' fill='#4a5568' />
                <rect x='283' y='178' width='14' height='3' rx='1' fill='#ef4444' />

                <line x1='290' y1='183' x2='290' y2='195' stroke='#ef4444' stroke-width='2' opacity='0.6' />
                <line x1='285' y1='183' x2='285' y2='193' stroke='#ef4444' stroke-width='1' opacity='0.4' />
                <line x1='295' y1='183' x2='295' y2='193' stroke='#ef4444' stroke-width='1' opacity='0.4' />

                {/*    <!-- Decorative Elements -->
                      <!-- Product Icons --> */}
                <circle cx='330' cy='120' r='12' fill='#ffffff' opacity='0.8' />
                <rect x='325' y='115' width='10' height='10' rx='1' fill='#4ba3c3' opacity='0.7' />

                <circle cx='350' cy='145' r='10' fill='#ffffff' opacity='0.8' />
                <rect x='346' y='141' width='8' height='8' rx='1' fill='#d4af37' opacity='0.7' />

                {/*  <!-- Barcode --> */}
                <rect x='60' y='120' width='3' height='25' fill='#2d3748' opacity='0.7' />
                <rect x='65' y='120' width='2' height='25' fill='#2d3748' opacity='0.7' />
                <rect x='69' y='120' width='4' height='25' fill='#2d3748' opacity='0.7' />
                <rect x='75' y='120' width='2' height='25' fill='#2d3748' opacity='0.7' />
                <rect x='79' y='120' width='3' height='25' fill='#2d3748' opacity='0.7' />
                <rect x='84' y='120' width='4' height='25' fill='#2d3748' opacity='0.7' />

                {/*  <!-- Signal Waves from POS --> */}
                <circle cx='200' cy='100' r='30' fill='none' stroke='#4ba3c3' stroke-width='1' opacity='0.3' />
                <circle cx='200' cy='100' r='40' fill='none' stroke='#4ba3c3' stroke-width='1' opacity='0.2' />
              </svg>

              <h2 class='pos-graphics-title'>Streamline Your Sales</h2>
              <p class='pos-graphics-subtitle'>Manage transactions, inventory, and customers all in one powerful platform</p>

              <div class='pos-features-grid'>
                <div class='pos-feature-badge'>
                  <div class='pos-feature-icon'>⚡</div>
                  <div class='pos-feature-text'>Fast</div>
                </div>
                <div class='pos-feature-badge'>
                  <div class='pos-feature-icon'>🔒</div>
                  <div class='pos-feature-text'>Secure</div>
                </div>
                <div class='pos-feature-badge'>
                  <div class='pos-feature-icon'>📊</div>
                  <div class='pos-feature-text'>Analytics</div>
                </div>
              </div>

              {/* <div class='pos-payment-section'>
                <div class='pos-payment-title'>Supported Payments</div>
                <div class='pos-payment-icons'>
                 
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='4' fill='#1434CB' />
                      <path
                        d='M18.5 11.5L16.2 20.5H14L16.3 11.5H18.5ZM24.8 16.8C24.8 17.5 24.2 18 23.3 18C22.8 18 22.4 17.9 22.1 17.7L21.9 16.5L22.1 16.6C22.5 16.8 22.9 16.9 23.4 16.9C23.8 16.9 24.1 16.7 24.1 16.4C24.1 16.2 23.9 16 23.5 15.8C23 15.6 22.2 15.2 22.2 14.3C22.2 13.3 23.1 12.5 24.5 12.5C25.1 12.5 25.6 12.6 26 12.8L25.8 14L25.5 13.8C25.2 13.7 24.8 13.6 24.4 13.6C24 13.6 23.7 13.8 23.7 14C23.7 14.2 24 14.4 24.5 14.6C25.2 14.9 25.5 15.3 25.5 15.9C25.4 17 24.5 17.8 23.1 17.8L24.8 16.8ZM30.2 11.5L28.5 20.5H26.4L28.1 11.5H30.2ZM34 11.5L36 20.5H34.2L34 19.5H31.5L31.1 20.5H29L32 11.5H34ZM33.5 18L32.8 14.5L32 18H33.5Z'
                        fill='white'
                      />
                    </svg>
                  </div>

               
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='4' fill='#EB001B' />
                      <circle cx='18' cy='16' r='8' fill='#FF5F00' />
                      <circle cx='30' cy='16' r='8' fill='#F79E1B' />
                      <path
                        d='M24 10.5C22.5 11.8 21.5 13.8 21.5 16C21.5 18.2 22.5 20.2 24 21.5C25.5 20.2 26.5 18.2 26.5 16C26.5 13.8 25.5 11.8 24 10.5Z'
                        fill='#FF5F00'
                      />
                    </svg>
                  </div>

              
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='4' fill='#00D09C' />
                      <circle cx='16' cy='16' r='6' fill='white' />
                      <path d='M24 10C27.3 10 30 12.7 30 16C30 19.3 27.3 22 24 22C20.7 22 18 19.3 18 16' fill='white' opacity='0.7' />
                      <text x='32' y='20' font-size='8' font-weight='bold' fill='white'>
                        Pay
                      </text>
                    </svg>
                  </div>

               
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='4' fill='#0055BA' />
                      <path d='M12 20L16 12L20 20H12Z' fill='#00D09C' />
                      <path d='M20 20L24 12L28 20H20Z' fill='white' />
                      <text x='29' y='20' font-size='6' font-weight='bold' fill='white'>
                        MP
                      </text>
                    </svg>
                  </div>
                </div>
              </div> */}
              <div class='pos-payment-section'>
                <div class='pos-payment-title'>Supported Payments</div>
                <div class='pos-payment-icons'>
                  {/* OPay */}
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='6' fill='#ffffff' stroke='#e5e7eb' stroke-width='1' />
                      <circle cx='14' cy='16' r='7' fill='#1DCF9F' />
                      <text x='23' y='20' font-size='10' font-weight='700' fill='#1DCF9F' font-family='Arial, sans-serif'>
                        Pay
                      </text>
                    </svg>
                  </div>

                  {/* Moniepoint */}
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='6' fill='#ffffff' />
                      <rect x='11' y='4' width='24' height='24' rx='8' fill='#1355FF' />
                      <text x='23' y='23' font-size='17' font-weight='800' fill='#ffffff' text-anchor='middle' font-family='Arial, sans-serif'>
                        M
                      </text>
                    </svg>
                  </div>

                  {/* Kuda */}
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='6' fill='#ffffff' stroke='#e5e7eb' stroke-width='1' />
                      <g stroke='#3E2278' stroke-width='1.6' stroke-linecap='round'>
                        <line x1='7' y1='9' x2='7' y2='23' />
                        <line x1='10.5' y1='9' x2='10.5' y2='23' />
                      </g>
                      <path d='M14 9 L20 16 L14 23' stroke='#3E2278' stroke-width='2.5' fill='none' stroke-linecap='round' stroke-linejoin='round' />
                      <text x='23' y='22' font-size='10.5' font-weight='800' fill='#3E2278' font-family='Arial, sans-serif'>
                        kuda.
                      </text>
                    </svg>
                  </div>

                  {/* Cash */}
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='6' fill='#ffffff' stroke='#e5e7eb' stroke-width='1' />
                      <circle cx='24' cy='16' r='10' fill='#16A34A' />
                      <text x='24' y='20' font-size='11' font-weight='800' fill='#ffffff' text-anchor='middle' font-family='Arial, sans-serif'>
                        N
                      </text>
                    </svg>
                  </div>

                  {/* Bank transfer */}
                  <div class='pos-payment-icon'>
                    <svg viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='48' height='32' rx='6' fill='#ffffff' stroke='#e5e7eb' stroke-width='1' />
                      <path d='M24 8 L34 13 H14 Z' fill='#3272ED' />
                      <rect x='15.5' y='14' width='3' height='9' fill='#3272ED' />
                      <rect x='22.5' y='14' width='3' height='9' fill='#3272ED' />
                      <rect x='29.5' y='14' width='3' height='9' fill='#3272ED' />
                      <rect x='13' y='23.5' width='22' height='2.5' rx='1' fill='#3272ED' />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*  <!-- Form Section --> */}
          <div class='pos-form-section'>
            <div style={{ justifyContent: "space-between" }} class='pos-logo-area'>
              <img
                style={{ width: "180px" }}
                src='https://res.cloudinary.com/ebuka1122/image/upload/v1760210570/static%20images%20storelens/storelense_logo_login_s1moxc.png'
                alt='storelense logo'
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  marginTop: "10px",
                }}
                onClick={() => {
                  window.location.href = "https://www.app.storelense.com/sign-in";
                }}
              >
                <div class='pos-logo-icon'>
                  <RiAdminFill size={24} />
                </div>
                <span class='pos-logo-text'>Admin</span>
                <BsArrowRightShort color='rgb(14, 73, 181)' size={27} style={{ marginTop: "4px" }} />
              </div>
            </div>

            <div class='pos-form-header'>
              <h1 class='pos-form-title'>Staff login</h1>
              <p class='pos-form-description'>Enter your boss email to access</p>
            </div>

            <form id='posLoginForm'>
              <div class='pos-input-group'>
                <label for='posEmailField' class='pos-input-label'>
                  Email Address
                </label>
                <div class='pos-input-wrapper'>
                  <svg class='pos-input-icon' width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path d='M22 6l-10 7L2 6' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                  </svg>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type='email'
                    id='posEmailField'
                    class='pos-email-input'
                    placeholder='you@example.com'
                    required
                  />
                </div>
                {!isEmailValid && email.length > 4 && (
                  <p style={{ alignSelf: "flex-start", marginTop: "10px" }} className='emailValidationP'>
                    Email not valid
                  </p>
                )}

                {/* <label for='posPasswordField' class='pos-input-label'>
                  Password
                </label>
                <div class='pos-input-wrapper'>
                  <svg class='pos-input-icon' width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <rect
                      x='3'
                      y='11'
                      width='18'
                      height='11'
                      rx='2'
                      ry='2'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path d='M7 11V7a5 5 0 0110 0v4' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                  </svg>
                  <input type='password' id='posPasswordField' class='pos-email-input' placeholder='Enter your password' required />
                </div> */}
              </div>

              <div class='pos-remember-section'>
                <label class='pos-checkbox-wrapper'>
                  <input type='checkbox' id='posRememberCheck' class='pos-custom-checkbox' />
                  <span class='pos-remember-label'>Remember me</span>
                </label>
              </div>

              {isEmailValid ? (
                <button disabled={isLoading} onClick={handleSignIn} type='submit' class='pos-submit-button'>
                  {isLoading ? <ButtonLoader /> : "Continue to login"}
                </button>
              ) : (
                <button style={{ opacity: "0.7", cursor: "not-allowed" }} type='submit' class='pos-submit-button'>
                  Continue to login
                </button>
              )}
            </form>

            <p class='pos-help-text'>
              Need help?{" "}
              <a href='#' class='pos-help-link'>
                Contact Support
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;

const logo = (
  <svg xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' width='46' height='46' viewBox='0 0 46 46'>
    <defs>
      <filter id='Ellipse_272'>
        <feOffset dx='-1' dy='1' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='5' result='blur' />
        <feFlood flood-color='#0f0f0f' flood-opacity='0.161' result='color' />
        <feComposite operator='out' in='SourceGraphic' in2='blur' />
        <feComposite operator='in' in='color' />
        <feComposite operator='in' in2='SourceGraphic' />
      </filter>
      <radialGradient
        id='radial-gradient'
        cx='0.862'
        cy='0.237'
        r='1.394'
        gradientTransform='translate(-0.13 0.179) rotate(-17.999)'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#5070a1' />
        <stop offset='1' stop-color='#0e49b5' />
      </radialGradient>
      <filter id='Subtraction_13' x='0.877' y='3.011' width='28.944' height='28.862' filterUnits='userSpaceOnUse'>
        <feOffset dx='-3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-2' />
        <feFlood flood-color='#434343' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-2' />
        <feComposite in='SourceGraphic' />
      </filter>
      <filter id='Subtraction_23' x='15.434' y='17.402' width='28.862' height='28.413' filterUnits='userSpaceOnUse'>
        <feOffset dy='3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-3' />
        <feFlood flood-color='#464646' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-3' />
        <feComposite in='SourceGraphic' />
      </filter>
    </defs>
    <g id='Group_2614' data-name='Group 2614' transform='translate(-0.037 -0.1)'>
      <g data-type='innerShadowGroup'>
        <circle id='Ellipse_272-2' data-name='Ellipse 272' cx='23' cy='23' r='23' transform='translate(0.037 0.099)' fill='#fff' />
        <g transform='matrix(1, 0, 0, 1, 0.04, 0.1)' filter='url(#Ellipse_272)'>
          <circle id='Ellipse_272-3' data-name='Ellipse 272' cx='23' cy='23' r='23' transform='translate(0 0)' fill='#fff' />
        </g>
        <g id='Ellipse_272-4' data-name='Ellipse 272' transform='translate(0.037 0.099)' fill='none' stroke='#0e49b5' stroke-width='2'>
          <circle cx='23' cy='23' r='23' stroke='none' />
          <circle cx='23' cy='23' r='22' fill='none' />
        </g>
      </g>
      <circle id='Ellipse_273' data-name='Ellipse 273' cx='18' cy='18' r='18' transform='translate(5.037 5.099)' fill='#c8a027' />
      <circle id='Ellipse_274' data-name='Ellipse 274' cx='17.5' cy='17.5' r='17.5' transform='translate(6.037 5.099)' fill='#fff' />
      <g id='Group_2610' data-name='Group 2610' transform='translate(12.416 12.111)'>
        <g transform='matrix(1, 0, 0, 1, -12.38, -12.01)' filter='url(#Subtraction_13)'>
          <path
            id='Subtraction_13-2'
            data-name='Subtraction 13'
            d='M10.943,10.862H0A10.554,10.554,0,0,1,3.19,3.326,11.63,11.63,0,0,1,10.944,0V10.861h0Z'
            transform='translate(12.88 12.01)'
            fill='url(#radial-gradient)'
          />
        </g>
        <path
          id='Subtraction_25'
          data-name='Subtraction 25'
          d='M10.8,0H0A10.623,10.623,0,0,0,3.148,7.536,11.406,11.406,0,0,0,10.8,10.862V0h0Z'
          transform='translate(22.854 10.862) rotate(180)'
          fill='#37b4c5'
        />
        <path
          id='Subtraction_17'
          data-name='Subtraction 17'
          d='M10.412,10.862H0A10.87,10.87,0,0,1,10.413,0V10.861h0Z'
          transform='translate(0.58 21.805) rotate(-90)'
          fill='#37b4c5'
        />
        <g transform='matrix(1, 0, 0, 1, -12.38, -12.01)' filter='url(#Subtraction_23)'>
          <path
            id='Subtraction_23-2'
            data-name='Subtraction 23'
            d='M10.412,0H0A10.825,10.825,0,0,0,3.035,7.536a10.813,10.813,0,0,0,7.378,3.325V0h0Z'
            transform='translate(24.43 33.82) rotate(-90)'
            fill='#0e49b5'
          />
        </g>
        <path
          id='Subtraction_12'
          data-name='Subtraction 12'
          d='M22.232,0H0A10.218,10.218,0,0,0,3.405,7.138a11.416,11.416,0,0,0,7.711,2.936,11.416,11.416,0,0,0,7.711-2.936A10.217,10.217,0,0,0,22.232,0Z'
          transform='translate(23.528 10.636) rotate(180)'
          fill='#fff'
        />
        <path
          id='Subtraction_26'
          data-name='Subtraction 26'
          d='M22.232,10.075H0A10.218,10.218,0,0,1,3.4,2.936,11.416,11.416,0,0,1,11.116,0a11.415,11.415,0,0,1,7.711,2.936,10.218,10.218,0,0,1,3.4,7.138Z'
          transform='translate(22.232 21.268) rotate(180)'
          fill='#fff'
        />
        <path id='Path_3551' data-name='Path 3551' d='M0,0H22.416' transform='translate(0.499 11.014)' fill='none' stroke='#0e49b5' stroke-width='1' />
      </g>
    </g>
  </svg>
);
